<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J0kbOW/tc-custom/9781460383230.jpg?1695744749206" alt="This image is the cover for the book Permanent Vacancy, Stepping Stones Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Permanent Vacancy, Stepping Stones Island
      </h1>
      <p class="bookDescription body article font2">
        <p>BUYER BEWARE <br/><br/>When Gretchen Bauer begins renovating an old Victorian house to turn it into a bed-and-breakfast, she barely escapes several dangerous "accidents" at her home. Colm McCrae, host of the home improvement TV show helping her renovate, refuses to believe these aren't on purpose. Could this be a harmful ploy by his boss to boost ratings? Yet with Colm's Irish brogue and handsome face, Gretchen wonders whether he could be involved. But with a whole town full of neighbors disgruntled about the inn bringing strangers to their shores, Gretchen has a list of more likely suspects. Now she must trust Colm if she wants to keep her new business venture from turning into a five-star death trap.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katy Lee
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?459bf74e